import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import UIComponent from './uiComponent';
import UIText from './uiText';
function NotesSourceHeaderComponent(props) {
    return (_jsxs("div", { className: "flex items-center", style: props.styling, children: [_jsx("div", { style: { width: props.leftSpace } }), _jsxs("div", { className: "whitespace-nowrap", style: { width: props.titleWidth }, children: [_jsxs("div", { className: "flex items-center gap-1 border-b border-black", children: [_jsx("span", { className: "font-semibold", children: props.title }), props.text && (_jsx(Popover, { content: props.text, trigger: "hover", overlayStyle: { width: 300 }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }))] }), _jsxs("div", { className: "flex items-center justify-between w-full gap-1", children: [props.subtitle1 && _jsx("div", { className: "text-xs", children: props.subtitle1 }), props.subtitle2 && _jsx("div", { className: "text-xs", children: props.subtitle2 })] })] }), _jsx("div", { className: "flex-1 border-t border-gray-300 ml-2" })] }));
}
export default class UINotesSourceHeader extends UIComponent {
    title;
    text;
    leftSpace;
    titleWidth;
    subtitle1;
    subtitle2;
    style;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title', "");
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.leftSpace = this.getProperty('leftSpace', "0px");
        this.titleWidth = this.getProperty('titleWidth', "100px");
        this.subtitle1 = this.getProperty('subtitle1', '');
        this.subtitle2 = this.getProperty('subtitle2', '');
        this.style = this.getProperty('style', '');
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            title: this.title,
            text: text,
            leftSpace: this.leftSpace,
            titleWidth: this.titleWidth,
            subtitle1: this.subtitle1,
            subtitle2: this.subtitle2,
            styling: this.style,
        };
        return _jsx(NotesSourceHeaderComponent, { ...props });
    }
}
//# sourceMappingURL=uiNotesSourceHeader.js.map